import React from 'react';
import { RefreshCw, CheckCircle, XCircle } from 'lucide-react';

const ProvisionalTab = ({ provisionalVehicles, pvLoading, onRefresh, onApprove, onReject }) => {
  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="bg-slate-800/50 rounded-2xl border border-slate-700 p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
          <h2 className="text-base sm:text-lg font-semibold text-white">Provisional Vehicles</h2>
          <button
            onClick={onRefresh}
            disabled={pvLoading}
            className="px-4 py-2 bg-slate-700 text-white rounded-lg hover:bg-slate-600 flex items-center gap-2 text-sm sm:text-base"
            data-testid="refresh-provisional-btn"
          >
            <RefreshCw className={`w-4 h-4 ${pvLoading ? 'animate-spin' : ''}`} />
            Refresh
          </button>
        </div>
        <p className="text-slate-400 text-xs sm:text-sm mb-4">
          Vehicles added by drivers as &ldquo;Other&rdquo; that need confirmation.
        </p>

        {/* Mobile Card View */}
        <div className="block sm:hidden divide-y divide-slate-700">
          {provisionalVehicles.length === 0 ? (
            <div className="py-6 text-center text-slate-400 text-sm">No provisional vehicles pending.</div>
          ) : (
            provisionalVehicles.map((v) => (
              <div key={v.vehicle_id} className="py-4">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <p className="text-white font-medium">{v.rego}</p>
                    <p className="text-slate-400 text-sm">{v.vehicle_class} | {v.gvm_kg || v.weight_kg || '-'} kg</p>
                  </div>
                  <p className="text-slate-500 text-xs">
                    {v.created_at ? new Date(v.created_at).toLocaleDateString() : '-'}
                  </p>
                </div>
                <p className="text-slate-500 text-xs mb-3">Added by: {v.added_by_name || 'Unknown'}</p>
                <div className="flex gap-2">
                  <button
                    onClick={() => onApprove(v.vehicle_id)}
                    className="flex-1 px-3 py-2 bg-emerald-500/20 text-emerald-400 rounded-lg hover:bg-emerald-500/30 flex items-center justify-center gap-1 text-sm"
                    data-testid={`approve-vehicle-${v.vehicle_id}`}
                  >
                    <CheckCircle className="w-4 h-4" /> Approve
                  </button>
                  <button
                    onClick={() => onReject(v.vehicle_id)}
                    className="flex-1 px-3 py-2 bg-red-500/20 text-red-400 rounded-lg hover:bg-red-500/30 flex items-center justify-center gap-1 text-sm"
                    data-testid={`reject-vehicle-${v.vehicle_id}`}
                  >
                    <XCircle className="w-4 h-4" /> Reject
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Desktop Table View */}
        <div className="hidden sm:block overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="text-left text-slate-400 text-sm">
                <th className="pb-4">Rego</th>
                <th className="pb-4">Class</th>
                <th className="pb-4">GVM (kg)</th>
                <th className="pb-4">Added By</th>
                <th className="pb-4">Date</th>
                <th className="pb-4">Actions</th>
              </tr>
            </thead>
            <tbody className="text-white">
              {provisionalVehicles.length === 0 ? (
                <tr>
                  <td colSpan={6} className="py-8 text-center text-slate-400">No provisional vehicles pending.</td>
                </tr>
              ) : (
                provisionalVehicles.map((v) => (
                  <tr key={v.vehicle_id} className="border-t border-slate-700">
                    <td className="py-4 font-medium">{v.rego}</td>
                    <td className="py-4">{v.vehicle_class}</td>
                    <td className="py-4">{v.gvm_kg || v.weight_kg || '-'}</td>
                    <td className="py-4 text-slate-400">{v.added_by_name || 'Unknown'}</td>
                    <td className="py-4 text-slate-400">
                      {v.created_at ? new Date(v.created_at).toLocaleDateString() : '-'}
                    </td>
                    <td className="py-4">
                      <div className="flex gap-2">
                        <button
                          onClick={() => onApprove(v.vehicle_id)}
                          className="px-3 py-1 bg-emerald-500/20 text-emerald-400 rounded-lg hover:bg-emerald-500/30 flex items-center gap-1"
                          data-testid={`approve-vehicle-${v.vehicle_id}`}
                        >
                          <CheckCircle className="w-4 h-4" /> Approve
                        </button>
                        <button
                          onClick={() => onReject(v.vehicle_id)}
                          className="px-3 py-1 bg-red-500/20 text-red-400 rounded-lg hover:bg-red-500/30 flex items-center gap-1"
                          data-testid={`reject-vehicle-${v.vehicle_id}`}
                        >
                          <XCircle className="w-4 h-4" /> Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProvisionalTab;
